import {
   HealthcareProviderNotificationConfiguration,
   HealthcareProviderWaitlistTimeSlotReservedPatientNotificationConfigurationQuery,
   HealthcareProviderWaitlistTimeSlotReservedTokenInConfirmationEnabledQuery,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';

type PatientPhoneNotificationWaitlistProposedAppointmentResponseTokenToggleLoaderRenderProps = {
   responseTokenEnabled: boolean;
   notificationEnabled: boolean;
};

type PatientPhoneNotificationWaitlistProposedAppointmentResponseTokenToggleLoaderProps = {
   readonly children: (
      renderProps: PatientPhoneNotificationWaitlistProposedAppointmentResponseTokenToggleLoaderRenderProps
   ) => JSX.Element;
};

export const PatientPhoneNotificationWaitlistProposedAppointmentResponseTokenToggleLoader = (
   props: PatientPhoneNotificationWaitlistProposedAppointmentResponseTokenToggleLoaderProps
): JSX.Element | null => {
   const {
      data: responseTokenEnabled,
      loading: responseTokenEnabledLoading,
      error: responseTokenEnabledError,
   } = useCqrsGet<boolean>(() => {
      return new HealthcareProviderWaitlistTimeSlotReservedTokenInConfirmationEnabledQuery();
   });

   const {
      data: healthcareProviderNotificationConfiguration,
      loading: healthcareProviderNotificationConfigurationLoading,
      error: healthcareProviderNotificationConfigurationError,
   } = useCqrsGet<HealthcareProviderNotificationConfiguration>(() => {
      return new HealthcareProviderWaitlistTimeSlotReservedPatientNotificationConfigurationQuery();
   });

   if (
      responseTokenEnabledLoading ||
      responseTokenEnabledError ||
      healthcareProviderNotificationConfigurationLoading ||
      healthcareProviderNotificationConfigurationError ||
      !healthcareProviderNotificationConfiguration
   ) {
      return null;
   }

   return props.children({
      responseTokenEnabled: responseTokenEnabled,
      notificationEnabled: healthcareProviderNotificationConfiguration.enabled,
   });
};
